import React, { useState, useCallback } from "react";
import { read, utils } from "xlsx";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveFile } from "../context/fileReducer";
import { saveError } from "../context/errorReducer";
import { useValidation } from "../hook/use_validation";

export const useImportFile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const { isRowsExists } = useValidation();
    const fileInputRef = React.useRef(null);

    const handleImport = useCallback((event) => {
        dispatch(saveError(null));
        sessionStorage.setItem("FailedRows", null);

        const files = event.target.files;
        if (!files.length) return;

        setLoading(true);
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const workbook = read(e.target.result);
            const sheetName = workbook.SheetNames?.[0];
            const sheetData = sheetName ? utils.sheet_to_json(workbook.Sheets[sheetName]) : [];

            if (isRowsExists(sheetData)) {
                dispatch(saveFile(sheetData));
                navigate("/uploadedFile");
            } else {
                setError(true);
                setLoading(false);
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        };

        reader.readAsArrayBuffer(file);
    }, [dispatch, isRowsExists, navigate]);

    return { handleImport, error, loading }
}